export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-heading text-2xl md:text-3xl text-foreground-950 mb-3">关于51漫画</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            致力于打造最流畅的中文漫画在线阅读体验
          </p>
        </div>
        <div className="max-w-3xl mx-auto bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/70">
          <div className="flex items-start gap-5">
            <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-xl flex-shrink-0">
              <i className="ri-book-read-line text-primary-500 text-xl"></i>
            </div>
            <div>
              <h3 className="text-heading text-lg text-foreground-900 mb-3">品牌故事</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                51漫画网成立于对漫画阅读体验的深度追求之上。我们理解每一位漫画爱好者对流畅阅读的渴望——
                翻页等待、加载延迟、画质模糊，这些都不该成为您享受漫画的障碍。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                平台收录超过十万部漫画作品，涵盖热血冒险、恋爱校园、奇幻异世界、悬疑推理等多元题材，
                每日更新超过200话全新内容。采用先进的下拉式加载技术，让51漫画在线观看变得前所未有的顺畅。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed">
                无论您是想重温经典还是追逐最新连载，51漫画在线看全集免费下拉式阅读为您免去下载烦恼，
                打开即看、下滑即读，高清画质让每一格分镜都栩栩如生。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}